const Board = () => {
  return(
    <div>
      <button>게시판입니다.</button>
    </div>
  )
}

export default Board;